import { render, staticRenderFns } from "./HistoryBox.vue?vue&type=template&id=1495ef14&"
import script from "./HistoryBox.vue?vue&type=script&lang=js&"
export * from "./HistoryBox.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBox.vue?vue&type=style&index=0&id=1495ef14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports